(() => {
  angular.module('app').component('hostCorporatesCreateEditCollateral', {
    templateUrl: require('./widget.html'),
    controller: CorporateEditCollateralController,
    controllerAs: 'vm',
    bindings: {
      corporateId: '<',
      currencyCode: '<',
      countryCode: '<',
      canEdit: '<',
    },
  });

  CorporateEditCollateralController.$inject = [
    '$uibModal',
    'moment',
    'abp.services.app.collateralEpisode',
    'Hms.MultiTenancy.CollateralType',
  ];

  function CorporateEditCollateralController(
    $uibModal,
    moment,
    collateralEpisodeSvc,
    enumCollateralType
  ) {
    const vm = this;

    // Bank Guarantee episodes expiring within this many days show an "Expires" badge. Once the
    // expiry date has passed they show an "Expired" badge until closed; they still count towards
    // the total.

    const expiryBadgeDays = 30;

    const typeLabelClasses = {
      [enumCollateralType.Escrow.id]: 'label-success',
      [enumCollateralType.BankGuarantee.id]: 'label-info',
      [enumCollateralType.DirectDebit.id]: 'label-warning',
    };

    vm.loading = 0;
    vm.totalAmount = 0;
    vm.episodes = [];

    vm.getTypeName = getTypeName;
    vm.getTypeLabelClass = getTypeLabelClass;
    vm.isBankGuarantee = isBankGuarantee;
    vm.isExpiringSoon = isExpiringSoon;
    vm.isExpired = isExpired;
    vm.viewHistory = viewHistory;
    vm.add = add;
    vm.close = close;
    vm.$onChanges = onChanges;

    // The container sets corporateId after loading the corporate, so load once it arrives.

    function onChanges(changes) {
      if (changes.corporateId && vm.corporateId) {
        getActiveCollateralEpisodes();
      }
    }

    function getActiveCollateralEpisodes() {
      vm.loading += 1;
      collateralEpisodeSvc
        .getActiveCollateralEpisodes({ id: vm.corporateId })
        .success((data) => {
          vm.totalAmount = data.totalAmount;
          vm.episodes = data.items;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getTypeName(collateralType) {
      const type = _.find(enumCollateralType.values, { id: collateralType });
      return type ? type.name : '';
    }

    function getTypeLabelClass(collateralType) {
      return typeLabelClasses[collateralType] || 'label-default';
    }

    function isBankGuarantee(episode) {
      return episode.collateralType === enumCollateralType.BankGuarantee.id;
    }

    // Expiring soon includes the expiry date itself.

    function isExpiringSoon(episode) {
      const daysToExpiry = getDaysToExpiry(episode);
      return daysToExpiry !== null && daysToExpiry >= 0 && daysToExpiry <= expiryBadgeDays;
    }

    function isExpired(episode) {
      const daysToExpiry = getDaysToExpiry(episode);
      return daysToExpiry !== null && daysToExpiry < 0;
    }

    // Null when the episode is not a Bank Guarantee or has no expiry date.

    function getDaysToExpiry(episode) {
      if (!isBankGuarantee(episode) || !episode.expiryDate) return null;

      return App.getLocalDate(episode.expiryDate).diff(moment().startOf('day'), 'days');
    }

    // Show every episode, closed and active. Read only, so nothing reloads afterwards.

    function viewHistory() {
      $uibModal.open({
        templateUrl: require('./collateralHistory.modal.html'),
        controller: 'host.views.corporates.createEdit.collateral.collateralHistory as vm',
        size: 'xl',
        resolve: {
          corporateId: () => vm.corporateId,
          currencyCode: () => vm.currencyCode,
        },
      });
    }

    // Open a new, independent collateral episode and reload the list once it is saved.

    function add() {
      $uibModal
        .open({
          templateUrl: require('./collateralAdd.modal.html'),
          controller: 'host.views.corporates.createEdit.collateral.collateralAdd as vm',
          backdrop: 'static',
          resolve: {
            corporateId: () => vm.corporateId,
            currencyCode: () => vm.currencyCode,
            countryCode: () => vm.countryCode,
          },
        })
        .result.then(() => {
          getActiveCollateralEpisodes();
        });
    }

    // Close this one episode and reload the list once it is saved. Other episodes are untouched.

    function close(episode) {
      $uibModal
        .open({
          templateUrl: require('./collateralClose.modal.html'),
          controller: 'host.views.corporates.createEdit.collateral.collateralClose as vm',
          backdrop: 'static',
          resolve: {
            episode: () => episode,
            currencyCode: () => vm.currencyCode,
          },
        })
        .result.then(() => {
          getActiveCollateralEpisodes();
        });
    }
  }
})();
